import moment from 'moment-timezone';
import store from '../../store/store'

// Formatter, when val is a string and looks like "YYYY-MM-DD HH:mm:ss", "2025-11-19 17:41:16"
const momentUtcToUserTz = (val) => {
	const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const userTimeZone = store.getState().user.user.settings.time_zone || localTZ;

	if (val) {
		const parsed = moment.utc(val, "YYYY-MM-DD HH:mm:ss", true);
		if (parsed.isValid()) {
			return parsed.tz(userTimeZone);
		}
		return moment.tz(val, userTimeZone);
	}

	return moment();
};

export default momentUtcToUserTz
